import { post,put,get,deleteRequest, postfd } from "../../../helpers/apihelpers";

export const UploadSaleBuildingAttachmentService=async(data)=>{
    try {
        const result = await postfd(`api/database/sale_building/upload_file`, data);
        return result;
    } catch (err) {
        return err.response;
    }
}

export const CreateSaleBuildingService=async(data)=>{
    try {
        const result = await post(`api/database/sale_building/create`, data);
        return result;
    } catch (err) {
        return err.response;
    }
}

export const UpdateSaleBuildingService=async(data,id)=>{
    try {
        const result = await put(`api/database/sale_building/update/${id}`, data);
        return result;
    } catch (err) {
        return err.response;
    }
}

export const GetSaleBuildingService=async(page,from_date,to_date,text,step=1)=>{
    try {
        const result = await get(`api/database/sale_building/get?page=${page}&from_date=${from_date}&to_date=${to_date}&text=${text}&step=${step}`,);
        return result;
    } catch (err) {
        return err.response;
    }
}

export const GetSaleBuildingDetailService=async(id)=>{
    try {
        const result = await get(`api/database/sale_building/get/${id}`,);
        return result;
    } catch (err) {
        return err.response;
    }
}

export const DeleteSaleBuildingService=async(id)=>{
    try {
        const result = await deleteRequest(`api/database/sale_building/delete/${id}`);
        return result;
    } catch (err) {
        return err.response;
    }
}

export const DeleteAdminSaleBuildingService=async(id)=>{
    try {
        const result = await deleteRequest(`api/database/sale_building/delete_admin/${id}`);
        return result;
    } catch (err) {
        return err.response;
    }
}

export const DeleteMassSaleBuildingService=async(data)=>{
    try {
        const result = await post(`api/database/sale_building/deleteMassMany`,data);
        return result;
    } catch (err) {
        return err.response;
    }
}


export const FilterSaleBuildingService=async(id)=>{
    try {
        const result = await get(`api/database/sale_building/delete/${id}`);
        return result;
    } catch (err) {
        return err.response;
    }
}

export const UploadSaleBuildingExcelService=async(data)=>{
    try {
        const result = await postfd(`api/database/sale_building/upload_excel`,data);
        return result;
    } catch (err) {
        return err.response;
    }
}

export const UploadSaleBuildingExcelService1=async(data)=>{
    try {
        const result = await postfd(`api/database/sale_building/upload_excel1`,data);
        return result;
    } catch (err) {
        return err.response;
    }
}

export const GenerateSaleBuildingPPTService=async(data)=>{
    try {
        const result = await post(`api/database/sale_building/generate_ppt`,data);
        return result;
    } catch (err) {
        return err.response;
    }
}


export const GetSaleBuildingHistoryService=async(page,id)=>{
    try {
        const result = await get(`api/database/sale_building/sale_building_history/${id}?page=${page}`);
        return result;
    } catch (err) {
        return err.response;
    } 
}

export const UpdateSaleBuildingHistoryService=async(id,data)=>{
    try {
        const result = await put(`api/database/sale_building/sale_building_history/${id}`,data);
        return result;
    } catch (err) {
        return err.response;
    } 
}

export const DeleteSaleBuildingHistoryService=async(id)=>{
    try {
        const result = await deleteRequest(`api/database/sale_building/sale_building_history/${id}`);
        return result;
    } catch (err) {
        return err.response;
    } 
}